import { toast } from "react-toastify";
import axiosInstance from "../../../utils/requestInstance";
import environment from "../../../enviroment";
const API_URL = environment.endPoint;




const ClientSerivces = {
  async createCompanyDetails(payload) {
    try {
      const response = await axiosInstance.post(`/companyOnboarding/createCompanyDetail`, payload);
      const data=response.data.result
      toast.success(data.message)
      return data;
    } catch (error) {
      console.log(error);
      toast.error(error.message)
    }
  },
  async createDirector(payload) {
    try {
      const response = await axiosInstance.post(`/companyOnboarding/createDirectorDetail`, payload);
      const data=response.data.result
      toast.success(data.message)
      return data;
    } catch (error) {
      console.log(error);
      toast.error(error.message)
    }
  },




//   async remove(id) {
//     try {
//       const response = await axiosInstance.delete(`/ClientSerivces/remove/${id}`);
//       let data=response.data.result
//       toast.success(data.message);
//     } catch (error) {
//       console.log(error);
//     }
//   },
//   async updateQuantity(id,payload) {
//     try {
//       const response = await axiosInstance.put(
//         `/ClientSerivces/updateQuantity/${id}`,
//         payload
//       );
//      let data=response.data.result;
// toast.success(data.message)
//       return data
//     } catch (error) {
//       console.log(error);
//       toast.error(error.message||"Internal Server Error");
//     }
//   },
};

export default ClientSerivces;